class ES9Static {

  static routeIn = {
    0: {
      name: 'USB 1',
      type: 'usb',
      linkIndex: 0,
    },
    1: {
      name: 'USB 2',
      type: 'usb',
      linkIndex: 0,
    },
    2: {
      name: 'USB 3',
      type: 'usb',
      linkIndex: 1,
    },
    3: {
      name: 'USB 4',
      type: 'usb',
      linkIndex: 1,
    },
    4: {
      name: 'USB 5',
      type: 'usb',
      linkIndex: 2,
    },
    5: {
      name: 'USB 6',
      type: 'usb',
      linkIndex: 2,
    },
    6: {
      name: 'USB 7',
      type: 'usb',
      linkIndex: 3,
    },
    7: {
      name: 'USB 8',
      type: 'usb',
      linkIndex: 3,
    },
    16: {
      name: 'USB 9',
      type: 'usb',
      linkIndex: 4,
    },
    17: {
      name: 'USB 10',
      type: 'usb',
      linkIndex: 4,
    },
    18: {
      name: 'USB 11',
      type: 'usb',
      linkIndex: 5,
    },
    19: {
      name: 'USB 12',
      type: 'usb',
      linkIndex: 5,
    },
    20: {
      name: 'USB 13',
      type: 'usb',
      linkIndex: 6,
    },
    21: {
      name: 'USB 14',
      type: 'usb',
      linkIndex: 6,
    },
    22: {
      name: 'USB 15',
      type: 'usb',
      linkIndex: 7,
    },
    23: {
      name: 'USB 16',
      type: 'usb',
      linkIndex: 7,
    },
    32: {
      name: 'Mix 1',
      type: 'mix',
      linkIndex: 0,
    },
    33: {
      name: 'Mix 2',
      type: 'mix',
      linkIndex: 0,
    },
    34: {
      name: 'Mix 3',
      type: 'mix',
      linkIndex: 1,
    },
    35: {
      name: 'Mix 4',
      type: 'mix',
      linkIndex: 1,
    },
    36: {
      name: 'Mix 5',
      type: 'mix',
      linkIndex: 2,
    },
    37: {
      name: 'Mix 6',
      type: 'mix',
      linkIndex: 2,
    },
    38: {
      name: 'Mix 7',
      type: 'mix',
      linkIndex: 3,
    },
    39: {
      name: 'Mix 8',
      type: 'mix',
      linkIndex: 3,
    },
    48: {
      name: 'S/PDIF L',
      type: 'spdif',
      linkIndex: 0,
    },
    49: {
      name: 'S/PDIF R',
      type: 'spdif',
      linkIndex: 0,
    },
    96: {
      name: 'Bus 1',
      type: 'bus',
      linkIndex: 0,
    },
    97: {
      name: 'Bus 2',
      type: 'bus',
      linkIndex: 0,
    },
    98: {
      name: 'Bus 3',
      type: 'bus',
      linkIndex: 1,
    },
    99: {
      name: 'Bus 4',
      type: 'bus',
      linkIndex: 1,
    },
    100: {
      name: 'Bus 5',
      type: 'bus',
      linkIndex: 2,
    },
    101: {
      name: 'Bus 6',
      type: 'bus',
      linkIndex: 2,
    },
    102: {
      name: 'Bus 7',
      type: 'bus',
      linkIndex: 3,
    },
    103: {
      name: 'Bus 8',
      type: 'bus',
      linkIndex: 3,
    },
    104: {
      name: 'Bus 9',
      type: 'bus',
      linkIndex: 4,
    },
    105: {
      name: 'Bus 10',
      type: 'bus',
      linkIndex: 4,
    },
    106: {
      name: 'Bus 11',
      type: 'bus',
      linkIndex: 5,
    },
    107: {
      name: 'Bus 12',
      type: 'bus',
      linkIndex: 5,
    },
    108: {
      name: 'Bus 13',
      type: 'bus',
      linkIndex: 6,
    },
    109: {
      name: 'Bus 14',
      type: 'bus',
      linkIndex: 6,
    },
    110: {
      name: 'Bus 15',
      type: 'bus',
      linkIndex: 7,
    },
    111: {
      name: 'Bus 16',
      type: 'bus',
      linkIndex: 7,
    },
    112: {
      name: 'Input 1',
      type: 'input',
      linkIndex: 0,
    },
    113: {
      name: 'Input 2',
      type: 'input',
      linkIndex: 0,
    },
    114: {
      name: 'Input 3',
      type: 'input',
      linkIndex: 1,
    },
    115: {
      name: 'Input 4',
      type: 'input',
      linkIndex: 1,
    },
    116: {
      name: 'Input 5',
      type: 'input',
      linkIndex: 2,
    },
    117: {
      name: 'Input 6',
      type: 'input',
      linkIndex: 2,
    },
    118: {
      name: 'Input 7',
      type: 'input',
      linkIndex: 3,
    },
    119: {
      name: 'Input 8',
      type: 'input',
      linkIndex: 3,
    },
    120: {
      name: 'Input 9',
      type: 'input',
      linkIndex: 4,
    },
    121: {
      name: 'Input 10',
      type: 'input',
      linkIndex: 4,
    },
    122: {
      name: 'Input 11',
      type: 'input',
      linkIndex: 5,
    },
    123: {
      name: 'Input 12',
      type: 'input',
      linkIndex: 5,
    },
    124: {
      name: 'Input 13',
      type: 'input',
      linkIndex: 6,
    },
    125: {
      name: 'Input 14',
      type: 'input',
      linkIndex: 6,
    },
  };

  static routeOut = {
    2: {
      name: 'Output 5',
    },
    3: {
      name: 'Output 6',
    },
    4: {
      name: 'Output 3',
    },
    5: {
      name: 'Output 4',
    },
    6: {
      name: 'Main Out L',
    },
    7: {
      name: 'Main Out R',
    },
    8: {
      name: 'Output 1',
    },
    9: {
      name: 'Output 2',
    },
    10: {
      name: 'Output 8',
    },
    11: {
      name: 'Output 7',
    },
    12: {
      name: 'Phones L',
    },
    13: {
      name: 'Phones R',
    },
    14: {
      name: 'ES-5 L',
    },
    15: {
      name: 'ES-5 R',
    },
    16: {
      name: 'Bus 1',
    },
    17: {
      name: 'Bus 2',
    },
    18: {
      name: 'Bus 3',
    },
    19: {
      name: 'Bus 4',
    },
    20: {
      name: 'Bus 5',
    },
    21: {
      name: 'Bus 6',
    },
    22: {
      name: 'Bus 7',
    },
    23: {
      name: 'Bus 8',
    },
    24: {
      name: 'Bus 9',
    },
    25: {
      name: 'Bus 10',
    },
    26: {
      name: 'Bus 11',
    },
    27: {
      name: 'Bus 12',
    },
    28: {
      name: 'Bus 13',
    },
    29: {
      name: 'Bus 14',
    },
    30: {
      name: 'Bus 15',
    },
    31: {
      name: 'Bus 16',
    },
  };
}

export default ES9Static;
